import _ from 'lodash'
import axios from '@/backend'

const defaultState = () => {
  return {
    id: null,
    mailbox_id: null,
    has_tags: [],
    name: ''
  }
}

const state = {
  subfolder_form: defaultState()
}

const getters = {
  subfolderForm (state) {
    return state.subfolder_form
  }
}

const mutations = {

  updateSubfolerForm (state, params) {
    let form = Object.assign({}, state.subfolder_form, params)
    _.set(state, 'subfolder_form', form)
  },

  setDefaultSubfolderForm (state) {
    _.set(state, 'subfolder_form', defaultState())
  },

  setSubfolder (state, subfolder) {
    let sub = Object.assign({}, state.subfolder_form, subfolder)
    sub.has_tags = sub.has_tags.map(tag => { return {label: tag, value: tag} })
    _.set(state, 'subfolder_form', sub)
  }

}

const actions = {

  saveSubfolder ({commit, rootState}) {
    let subfolder = Object.assign({}, state.subfolder_form)
    let baseUrl = 'mailboxes/' + subfolder.mailbox_id + '/subfolders'
    subfolder.has_tags = subfolder.has_tags.map(tag => tag.value)
    if (subfolder.id) {
      return axios.put(baseUrl + '/' + subfolder.id, {subfolder: subfolder}).then(response => {
        return response
      }, error => {
        console.log(error)
      })
    } else {
      return axios.post(baseUrl, {subfolder: subfolder}).then(response => {
        return response
      }, error => {
        console.log(error)
      })
    }
  },

  getSubfolder ({commit, dispatch}, [subfolderId, mailboxId]) {
    axios.get('mailboxes/' + mailboxId + '/subfolders/' + subfolderId)
      .then(function (response) {
        commit('setSubfolder', response.data)
      })
      .catch(e => { console.log(e.response) })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/subfolder_form.js